var map = {
	"./P1_front.png": "iSXJ",
	"./P1_front_foot_120mm.png": "X2V5",
	"./P1_side_foot_120mm.png": "FMCj",
	"./P1_side_left.png": "0yUj",
	"./P1_side_right.png": "agkg",
	"./P1_side_right2.png": "Dlnh",
	"./P2_front.png": "TiPR",
	"./P2_front_foot_46mm.png": "N74w",
	"./P2_front_foot_60mm.png": "fPhj",
	"./P2_side_foot_46mm.png": "SYUL",
	"./P2_side_foot_60mm.png": "88kN",
	"./P2_side_left.png": "qA37",
	"./P2_side_right.png": "pXQz",
	"./P2_side_right2.png": "E5gc",
	"./btn_move.png": "g6ax",
	"./btn_move_hover.png": "0Gxk",
	"./light.png": "H62e",
	"./line.png": "Se/C",
	"./line_blue.png": "2cM8",
	"./man-front.png": "B58B",
	"./man-side.png": "mwS/",
	"./mark_P1.png": "1c7w",
	"./mark_P2.png": "njtQ",
	"./screen.png": "GP6x",
	"./screen_side.png": "DoCW",
	"./wall.png": "wsOz",
	"./white_board.png": "PDf6",
	"./white_board_screen.png": "auyO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZCS+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST ^\.\/.*$
// module id = ZCS+
// module chunks = 3